import { useMemo } from 'react';
import FilteredCaption from './FilteredCaption';
import { count_covoyagers } from './utils';
import { CAPTION_FONT_SIZE } from './constants';

// The summary line, built from whichever pair of counts it is describing.
// The trips clause is dropped for a lone trip, but only on the say-so of the
// unfiltered line, so that the filtered line below it stays directly comparable.
const summary_text = (num_covoyagers, num_trips, show_trips) => {
  const covoyagers_text = (num_covoyagers === 1) ? "1 co-voyager" : `${num_covoyagers} co-voyagers`;
  const trips_text = !show_trips       ? "" :
                     (num_trips === 1) ? " across 1 trip" :
                                         ` across ${num_trips} trips`;
  return `${covoyagers_text}${trips_text}`;
};

const PersonCaption = ({ person }) => {

    const [num_covoyagers, filtered_num_covoyagers] = useMemo(() => {
      if (person === null) {
        return [0, 0];
      }
      return [count_covoyagers(person, false), count_covoyagers(person, true)];
    }, [person]);

    if (person === null) {
      return null;
    }

    const num_trips = person.person_trips.length;
    const filtered_num_trips = person.person_trips.filter((pt) => pt.in_filter).length;
    const first_trip_text = person.person_trips[0].trip.trip_date;
    const last_trip_text = person.person_trips[num_trips-1].trip.trip_date;
    const trip_dates_text = (num_trips > 1) ? `${first_trip_text} to ${last_trip_text}` : first_trip_text;
    const show_trips = num_trips > 1;
    const person_text = summary_text(num_covoyagers, num_trips, show_trips);
    const filtered_person_text = summary_text(filtered_num_covoyagers, filtered_num_trips, show_trips);
    // Comparing the two lines, rather than the counts they were built from, so
    // the filtered line only appears when it would actually read differently.
    const show_filtered = filtered_person_text !== person_text;

    return (
      <g fill="white"
         textAnchor="middle"
         className="person_caption"
         style={{fontSize: CAPTION_FONT_SIZE}}>
        <text dy="-0.45em">{person.name}</text>
        <text dy="1.15em">{trip_dates_text}</text>
        <text dy="2.75em">{person_text}</text>
        {show_filtered && <FilteredCaption text={filtered_person_text} dy="4.35em" />}
      </g>
    );
  };

  export default PersonCaption;
